import { isNil } from 'lodash';

/**
 * @template T
 * @param {T | null | undefined} value
 * @returns {T}
 */
export function assertIsNotNil(value) {
  if (isNil(value)) {
    throw new Error(`value is unexpectedly nil (${value})`);
  }
  return value;
}
